import { createAction, props } from '@ngrx/store';
import { IPaymentInfo } from '@dch/billing-business-logic';

export const GET_BILLING_PAYMENT_INFO_REQUEST =
  'GET_BILLING_PAYMENT_INFO_REQUEST';
export const GET_BILLING_PAYMENT_INFO_SUCCESS =
  'GET_BILLING_PAYMENT_INFO_SUCCESS';
export const GET_BILLING_PAYMENT_INFO_FAILURE =
  'GET_BILLING_PAYMENT_INFO_FAILURE';

export const getBillingPaymentInfoRequest = createAction(
  GET_BILLING_PAYMENT_INFO_REQUEST,
  props<{ billingAccountNumber: string }>()
);

export const getBillingPaymentInfoSuccess = createAction(
  GET_BILLING_PAYMENT_INFO_SUCCESS,
  props<{ billingAccountNumber: string; paymentInfo: IPaymentInfo }>()
);

export const getBillingPaymentInfoFailure = createAction(
  GET_BILLING_PAYMENT_INFO_FAILURE,
  props<{ billingAccountNumber: string }>()
);
